<p-button
  label="Start Manually"
  size="large"
  variant="outlined"
  [rounded]="true"
  icon="pi pi-file-edit"
  severity="secondary"
  [disabled]="disabled"
  (click)="handleClick()" />
